
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hs7Sl", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");





var $9EOlJ = parcelRequire("9EOlJ");


var $7akNQ = parcelRequire("7akNQ");


var $iDrrr = parcelRequire("iDrrr");


var $8Qsoy = parcelRequire("8Qsoy");





var $kSwu1 = parcelRequire("kSwu1");





var $4MnFz = parcelRequire("4MnFz");


var $24dy7 = parcelRequire("24dy7");


var $chu6R = parcelRequire("chu6R");





var $gXfti = parcelRequire("gXfti");


var $B5pjk = parcelRequire("B5pjk");

var $9Y4TN = parcelRequire("9Y4TN");





var $64VTj = parcelRequire("64VTj");


var $2tDQa = parcelRequire("2tDQa");































const $6c01a66802704a85$var$locales = {
    cs: ()=>(parcelRequire("gkwow")),
    da: ()=>(parcelRequire("6aK6W")),
    de: ()=>(parcelRequire("hx6ki")),
    'en-GB': ()=>(parcelRequire("6NqkL")),
    'en-ZZ': ()=>(parcelRequire("ajPmq")),
    en: ()=>Promise.resolve((parcelRequire("2tDQa"))),
    es: ()=>(parcelRequire("gT5vh")),
    fi: ()=>(parcelRequire("lw3hP")),
    fr: ()=>(parcelRequire("kdctd")),
    hu: ()=>(parcelRequire("1PGa9")),
    it: ()=>(parcelRequire("hKcus")),
    ja: ()=>(parcelRequire("dhpjR")),
    ko: ()=>(parcelRequire("8YZ4p")),
    nb: ()=>(parcelRequire("4N1kk")),
    nl: ()=>(parcelRequire("11IwJ")),
    pl: ()=>(parcelRequire("7i3vo")),
    'pt-BR': ()=>(parcelRequire("eKvi3")),
    ru: ()=>(parcelRequire("bY0VN")),
    sl: ()=>(parcelRequire("7yzEr")),
    sr_RS: ()=>(parcelRequire("1yiJi")),
    sr_YR: ()=>(parcelRequire("kXi26")),
    sv: ()=>(parcelRequire("iB2D9")),
    th: ()=>(parcelRequire("5wSQ4")),
    tr: ()=>(parcelRequire("9GACM")),
    uk: ()=>(parcelRequire("ex0q7")),
    vi: ()=>(parcelRequire("ksIbs")),
    zh_TW: ()=>(parcelRequire("1O1cp")),
    zh: ()=>(parcelRequire("bCWCz"))
};
const $6c01a66802704a85$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const messages = await $6c01a66802704a85$var$locales[locale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await $6c01a66802704a85$var$locales[parentLocale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
};


const $32a81d6e2279fe8c$export$9aa38aed134c207f = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
        defaultMessages: (0, $2tDQa.default),
        loaderFn: (0, $6c01a66802704a85$export$2b153a2030b0feb2)
    }, children);
};






var $bkTet = parcelRequire("bkTet");


var $6LqoL = parcelRequire("6LqoL");

var $1Qi0Q = parcelRequire("1Qi0Q");


var $3uUvc = parcelRequire("3uUvc");





var $TTB05 = parcelRequire("TTB05");





var $jeWt2 = parcelRequire("jeWt2");


var $8SjBl = parcelRequire("8SjBl");





var $bvGYI = parcelRequire("bvGYI");


var $fkeeB = parcelRequire("fkeeB");
















const $5d68949e5c8b2b44$var$pruneLegacyProperties = (updatedPreferences)=>{
    // Strips any possible V002/legacy properties from the preferences by excluding everything but the core prefs
    return {
        [(0, $TTB05.PreferenceCategory).StrictlyNecessary]: updatedPreferences[(0, $TTB05.PreferenceCategory).StrictlyNecessary],
        [(0, $TTB05.PreferenceCategory).Functional]: updatedPreferences[(0, $TTB05.PreferenceCategory).Functional],
        [(0, $TTB05.PreferenceCategory).Analytics]: updatedPreferences[(0, $TTB05.PreferenceCategory).Analytics],
        [(0, $TTB05.PreferenceCategory).Marketing]: updatedPreferences[(0, $TTB05.PreferenceCategory).Marketing],
        [(0, $TTB05.PreferenceCategory).Unknown]: updatedPreferences[(0, $TTB05.PreferenceCategory).Unknown]
    };
};
const $5d68949e5c8b2b44$var$setContextualConsentProperties = (consentPreferences, usingPrefetchedData)=>{
    // When merging during this phase, retain the "unauthed/authed" context of the preferences
    const existingUserAuthenticatedState = consentPreferences?.[(0, $TTB05.ContextualConsentProperty).UserIsAuthenticated];
    const existingConsentHubUnavailableState = !!consentPreferences?.[(0, $TTB05.ContextualConsentProperty).ConsentDataUnavailable];
    // When processing a legacy token, UserIsAuthenticated will be missing, so we need to backfill it with context from ConsentHubUnavailable
    const existingOrBackfilledAuthState = existingUserAuthenticatedState === undefined ? !existingConsentHubUnavailableState : existingUserAuthenticatedState;
    // Overwriting this flag while merging here gets us into a situation where a prefetched/cached, default cookie is just being set in the system,
    // but we mark the consents as "genuine", when they haven't actually been saved.
    // Doing this would have negative downstream effects, as we invoke logic dependent on if a token is a default or not
    const existingDefaultState = !!consentPreferences?.[(0, $TTB05.ContextualConsentProperty).ConsentsAreDefault];
    const consentsAreDefault = usingPrefetchedData ? existingDefaultState : false;
    return {
        [(0, $TTB05.ContextualConsentProperty).ConsentsAreDefault]: consentsAreDefault,
        [(0, $TTB05.ContextualConsentProperty).UserIsAuthenticated]: existingOrBackfilledAuthState,
        [(0, $TTB05.ContextualConsentProperty).ConsentDataUnavailable]: existingConsentHubUnavailableState
    };
};
const $5d68949e5c8b2b44$export$c0214a364df3006f = (updatedPreferences, usingPrefetchedData)=>{
    // DEFAULT_PREFERENCES now gives us "CH unavailable" and "is default" bits
    const existingPrefs = (0, $1Qi0Q.getCookie)((0, $bkTet.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (existingPrefs) {
        // Unpacking a V2 should now result in a V3 token anyway, but ensure we have proper bits
        const unpackedExistingPrefs = (0, $fkeeB.unpackUserPreferencesCookie)(existingPrefs);
        // Capture any missed options (shouldn't have any if we have existing consent token), and
        // ensure we write the bit dictating that these consents are no longer defaults since they're being saved
        if (unpackedExistingPrefs) return {
            ...(0, $bkTet.DEFAULT_PREFERENCES),
            ...unpackedExistingPrefs,
            ...$5d68949e5c8b2b44$var$pruneLegacyProperties(updatedPreferences),
            ...$5d68949e5c8b2b44$var$setContextualConsentProperties(unpackedExistingPrefs, usingPrefetchedData)
        };
        return {
            ...(0, $bkTet.DEFAULT_PREFERENCES),
            ...$5d68949e5c8b2b44$var$pruneLegacyProperties(updatedPreferences)
        };
    }
    // If we don't have existing prefs, this is likely a first time save for this domain
    // Ensure we note this is a successful, genuine set of prefs by updating the contextual properties as needed
    return {
        ...(0, $bkTet.DEFAULT_PREFERENCES),
        ...$5d68949e5c8b2b44$var$pruneLegacyProperties(updatedPreferences),
        ...$5d68949e5c8b2b44$var$setContextualConsentProperties(updatedPreferences, usingPrefetchedData)
    };
};
const $5d68949e5c8b2b44$export$a023a0b818522757 = (consentToken)=>{
    // Diff the token we're trying to set vs. any existing fallback, and only set a new fallback if the value has changed.
    // A difference would mean the user made a change since their original fallback was stored and we should update.
    // Otherwise, we would be unintentionally overriding the "1 year" expiration date the fallback token tracks.
    const existingFallbackToken = (0, $1Qi0Q.getCookie)((0, $bkTet.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const tokenDiffersFromOldFallback = existingFallbackToken !== consentToken;
    if (!existingFallbackToken || tokenDiffersFromOldFallback) (0, $bvGYI.setConsentTokenFallbackCookie)(consentToken);
};


const $b7db36f6b0e9b8a2$export$c8a8f3474b56fa5f = (mergedPrefs, usingPrefetchedData)=>{
    // If platform_moonjelly_bsc_fallback_token_audit feature gate is on,
    // use new fallback consent token logic
    // On a successful save, transform the prefs object into a formatted consentToken bit string
    // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
    const consentToken = (0, $fkeeB.packUserPreferences)(mergedPrefs);
    // Check if the token is prefetched and set to default.
    if (usingPrefetchedData && (0, $8SjBl.checkIfTokenIsDefault)(consentToken)) return;
    if (usingPrefetchedData) (0, $5d68949e5c8b2b44$export$a023a0b818522757)(consentToken);
    else (0, $bvGYI.setConsentTokenFallbackCookie)(consentToken);
    (0, $bvGYI.setConsentTokenCookie)(consentToken);
    (0, $bvGYI.setShouldShowBannerCookie)(consentToken);
};
const $b7db36f6b0e9b8a2$export$2c4e14a9e4d984da = (err, mergedPrefs)=>{
    const errorDueToUnauthenticatedRequest = err instanceof (0, $8SjBl.StatusCodeError) && err.status === 401;
    const errorDueToConsentHubBeingInaccessible = err instanceof (0, $8SjBl.StatusCodeError) && err.status >= 500 && err.status < 600; // Any 5xx error
    // Indicates the user is genuinely logged out instead of ConsentHub being inaccessible
    // If we dont explicitly 401, defer to the previous auth state
    const updatedAuthState = errorDueToUnauthenticatedRequest ? !errorDueToUnauthenticatedRequest : !!mergedPrefs[(0, $TTB05.ContextualConsentProperty).UserIsAuthenticated];
    const consentToken = (0, $fkeeB.packUserPreferences)({
        ...mergedPrefs,
        [(0, $TTB05.ContextualConsentProperty).UserIsAuthenticated]: updatedAuthState,
        [(0, $TTB05.ContextualConsentProperty).ConsentDataUnavailable]: errorDueToConsentHubBeingInaccessible
    });
    if (errorDueToUnauthenticatedRequest) {
        // When the failure is derived from a local-only/unauthenticated user, we need to also set the consent token
        // Otherwise, we will never actually adhere to their consents, as they'll continue to receive default every time we attempt to unsuccessfully fetch their prefs
        (0, $8Qsoy.Logger).error(`User is unauthenticated. ${err.message}`);
        (0, $5d68949e5c8b2b44$export$a023a0b818522757)(consentToken);
        (0, $bvGYI.setConsentTokenCookie)(consentToken);
        (0, $bvGYI.setShouldShowBannerCookie)(consentToken);
        return;
    }
    // When there's an actual failure, we only store data in the fallbackConsentToken cookie
    // This allows us to still track consents when ConsentHub is down beyond the short-lived
    // consent token cookie's expiry
    // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
    // This circumvents an issue of a user thinking they saved consents to CH, but when we request them later,
    // CH has no record of them, and they get shown the banner again
    (0, $8Qsoy.Logger).error('Token failed to save');
    (0, $5d68949e5c8b2b44$export$a023a0b818522757)(consentToken);
    (0, $bvGYI.setShouldShowBannerCookie)(consentToken);
};
const $b7db36f6b0e9b8a2$export$fbf549fe6f0e91dc = async (updatedPreferences, displayedTextMap, usingPrefetchedData)=>{
    const mergedPrefs = (0, $5d68949e5c8b2b44$export$c0214a364df3006f)(updatedPreferences, usingPrefetchedData);
    try {
        if (!usingPrefetchedData) // Attempts to save the newly updated preferences object
        // Can only be saved when a user is logged in, so this error will be caught if unauthed
        await (0, $jeWt2.saveConsentPreferences)(mergedPrefs, displayedTextMap);
        $b7db36f6b0e9b8a2$export$c8a8f3474b56fa5f(mergedPrefs, usingPrefetchedData);
    } catch (err) {
        // If we fail to save to ConsentHub, it could be due to ConsentHub being down, the user being unauthenticated/local-only,
        // or an exception somewhere in the stack. Ensure we pack that information into the token where applicable.
        $b7db36f6b0e9b8a2$export$2c4e14a9e4d984da(err, mergedPrefs);
    }
};



var $cnzke = parcelRequire("cnzke");




const $b25b202b7ea25dac$var$emptyDisplayedTextMap = {
    [(0, $TTB05.PreferenceCategory).Analytics]: '',
    [(0, $TTB05.PreferenceCategory).Functional]: '',
    [(0, $TTB05.PreferenceCategory).Marketing]: '',
    [(0, $TTB05.PreferenceCategory).StrictlyNecessary]: '',
    [(0, $TTB05.PreferenceCategory).Unknown]: ''
};
async function $b25b202b7ea25dac$export$7bb3e177c1a1e841(preferences, displayedTextMap = $b25b202b7ea25dac$var$emptyDisplayedTextMap, usingPrefetchedData) {
    if ((0, $3uUvc.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $fkeeB.packUserPreferences)(preferences);
        (0, $cnzke.setStrictlyNecessaryCookie)((0, $bkTet.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY), packedPrefs, {
            expires: 365,
            path: '/'
        });
    } else await (0, $b7db36f6b0e9b8a2$export$fbf549fe6f0e91dc)(preferences, displayedTextMap, usingPrefetchedData);
}





const $f9643a32e1be39e4$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    preferencesBtn: {
        id: "browser-storage-controls.consent-banner.preferences.button",
        defaultMessage: "Preferences"
    },
    onlyNecessaryBtn: {
        id: "browser-storage-controls.consent-banner.only-necessary.button",
        defaultMessage: "Only necessary"
    },
    acceptAllBtn: {
        id: "browser-storage-controls.consent-banner.accept-all.button",
        defaultMessage: "Accept all"
    },
    cookiesTrackingNotice: {
        id: "browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024",
        defaultMessage: "Atlassian cookies and tracking notice"
    },
    useCookiesDescription: {
        id: "browser-storage-controls.consent-banner.cookies-description.text",
        defaultMessage: "Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}"
    },
    useCookiesDescriptionNoLink: {
        id: "browser-storage-controls.consent-banner.cookies-description.text.no.link",
        defaultMessage: "Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device."
    },
    successFlagTitle: {
        id: "browser-storage-controls.consent-banner.success-flag.title",
        defaultMessage: "Cookie preferences saved"
    },
    successFlagDescription: {
        id: "browser-storage-controls.consent-banner.success-flag.description",
        defaultMessage: "You can change this at any time in your Atlassian account."
    },
    successFlagDescriptionLocalOnly: {
        id: "browser-storage-controls.consent-banner.success-flag.description-local-only",
        defaultMessage: "Your preferences will only affect this site."
    },
    errorFlagTitle: {
        id: "browser-storage-controls.consent-banner.error-flag.title",
        defaultMessage: "We're unable to update the policy"
    },
    errorFlagDescription: {
        id: "browser-storage-controls.consent-banner.error-flag.description",
        defaultMessage: "Try again in a few minutes."
    }
});





























var $7ZB0A = parcelRequire("7ZB0A");


var $dTHYM = parcelRequire("dTHYM");


var $I7hWB = parcelRequire("I7hWB");


var $cDs9S = parcelRequire("cDs9S");


var $aGB72 = parcelRequire("aGB72");


var $fEPJS = parcelRequire("fEPJS");


var $7aRdF = parcelRequire("7aRdF");


var $eQiT1 = parcelRequire("eQiT1");


var $aRGok = parcelRequire("aRGok");





var $l8Rhq = parcelRequire("l8Rhq");

var $3izAL = parcelRequire("3izAL");

var $2wCqQ = parcelRequire("2wCqQ");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");







const $a43d3eee5666acfd$export$99df83ca0f45bd54 = [
    (0, $TTB05.PreferenceCategory).Analytics,
    (0, $TTB05.PreferenceCategory).Functional,
    (0, $TTB05.PreferenceCategory).Marketing,
    (0, $TTB05.PreferenceCategory).StrictlyNecessary,
    (0, $TTB05.PreferenceCategory).Unknown
];









var $2uDbg = parcelRequire("2uDbg");














const $8789ec7a75950bdd$var$tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';
// Styles
const $8789ec7a75950bdd$var$categoryBoxStyles = (0, $buxP3.xcss)({
    paddingBlockStart: 'space.200'
});
const $8789ec7a75950bdd$var$categoryDescriptionStyles = (0, $buxP3.xcss)({
    paddingInlineStart: 'space.300',
    marginInlineStart: 'space.050'
});
// We don't bother tracking unknown checkbox toggles
const $8789ec7a75950bdd$var$categoryToEventSubjectMap = {
    [(0, $TTB05.PreferenceCategory).Analytics]: 'performanceConsent',
    [(0, $TTB05.PreferenceCategory).Functional]: 'functionalConsent',
    [(0, $TTB05.PreferenceCategory).Marketing]: 'targetingConsent',
    [(0, $TTB05.PreferenceCategory).Unknown]: null,
    [(0, $TTB05.PreferenceCategory).StrictlyNecessary]: null
};
const $8789ec7a75950bdd$var$categoryToTestIdMap = {
    [(0, $TTB05.PreferenceCategory).StrictlyNecessary]: null,
    [(0, $TTB05.PreferenceCategory).Analytics]: 'analytics',
    [(0, $TTB05.PreferenceCategory).Functional]: 'functional',
    [(0, $TTB05.PreferenceCategory).Marketing]: 'marketing',
    [(0, $TTB05.PreferenceCategory).Unknown]: null
};
const $8789ec7a75950bdd$export$3c97a3b492e10ae9 = ({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: descriptionElement, isChecked: isChecked, setPreferencesData: setPreferencesData })=>{
    const onCheckboxChange = (0, $cozmU.useCallback)(()=>{
        // Don't alter cookies that are strictly necessary
        if (category === (0, $TTB05.PreferenceCategory).StrictlyNecessary) return;
        setPreferencesData((prevPrefsData)=>{
            const isSelected = prevPrefsData.prefs && !prevPrefsData.prefs[category];
            const actionSubjectId = $8789ec7a75950bdd$var$categoryToEventSubjectMap[category];
            if (actionSubjectId) (0, $9Y4TN.sendUIEvent)({
                actionSubjectId: actionSubjectId,
                action: 'clicked',
                actionSubject: 'checkbox',
                source: 'cookieConsentModal',
                attributes: {
                    isSelected: isSelected
                }
            });
            return {
                ...prevPrefsData,
                prefs: {
                    ...prevPrefsData.prefs,
                    [category]: isSelected
                }
            };
        });
    }, [
        category,
        setPreferencesData
    ]);
    const descriptionId = `consent-preference-${$8789ec7a75950bdd$var$categoryToTestIdMap[category]}-description`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $8789ec7a75950bdd$var$categoryBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: `${$8789ec7a75950bdd$var$tmpTrelloClassNameOverride}`,
        isChecked: isChecked,
        value: isChecked.toString(),
        onChange: onCheckboxChange,
        label: titleElement,
        name: `${titleString}`,
        testId: `consent-preference-${$8789ec7a75950bdd$var$categoryToTestIdMap[category]}`,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $8789ec7a75950bdd$var$categoryDescriptionStyles,
        id: descriptionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        size: "small",
        color: "color.text.subtle"
    }, descriptionElement)));
};





const $2d171512d668e5ad$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    title: {
        id: "browser-storage-controls.consent-banner-modal.title",
        defaultMessage: "Cookie preferences"
    },
    summaryDescription: {
        id: "browser-storage-controls.consent-banner-modal.summary.description.082624",
        defaultMessage: "Because we value your privacy, you can select which cookies you allow. {link}"
    },
    strictDescription: {
        id: "browser-storage-controls.consent-banner-modal.strict.description.082624",
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits."
    },
    confirmBtn: {
        id: "browser-storage-controls.consent-banner-modal.confirm.button",
        defaultMessage: "Confirm"
    },
    cancelBtn: {
        id: "browser-storage-controls.consent-banner-modal.cancel.button",
        defaultMessage: "Cancel"
    },
    trackingLink: {
        id: "browser-storage-controls.consent-banner-modal.tracking.link.082624",
        defaultMessage: "Review our cookies and tracking notice"
    },
    functionalOption: {
        id: "browser-storage-controls.consent-banner-modal.functional.option.082624",
        defaultMessage: "Allow functional cookies"
    },
    functionalOptionDescription: {
        id: "browser-storage-controls.consent-banner-modal.functional.description.082624",
        defaultMessage: "Provides enhanced functionality and personalization."
    },
    analyticalOption: {
        id: "browser-storage-controls.consent-banner-modal.analytical.option.082624",
        defaultMessage: "Allow analytical cookies"
    },
    analyticalOptionDescription: {
        id: "browser-storage-controls.consent-banner-modal.analytical.description.101024",
        defaultMessage: "Measures usage to improve product performance."
    },
    marketingOption: {
        id: "browser-storage-controls.consent-banner-modal.marketing.option.082624",
        defaultMessage: "Allow marketing cookies"
    },
    marketingOptionDescription: {
        id: "browser-storage-controls.consent-banner-modal.marketing.description.082624",
        defaultMessage: "Used for targeted advertising."
    },
    strictDescriptionAppify: {
        id: "browser-storage-controls.consent-banner-modal.strict.description.082624-appify",
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits."
    },
    analyticalOptionDescriptionAppify: {
        id: "browser-storage-controls.consent-banner-modal.analytical.description.101024-appify",
        defaultMessage: "Measures usage to improve app performance."
    }
});


const $95f2e490b44865a6$var$categoryNameStyles = (0, $buxP3.xcss)({
    fontWeight: 'font.weight.bold'
});
const $95f2e490b44865a6$var$customHeaderStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse'
});
const $95f2e490b44865a6$var$extractTextFromReactNode = (node)=>{
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map($95f2e490b44865a6$var$extractTextFromReactNode).join('');
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) {
        if (node.props.children) return $95f2e490b44865a6$var$extractTextFromReactNode(node.props.children);
    }
    return '';
};
const $95f2e490b44865a6$var$getDefaultText = (intl)=>{
    const link = intl.formatMessage((0, $2d171512d668e5ad$export$a7357cdd1f0b0168).trackingLink);
    const defaultSummaryDescriptionDisplayedText = intl.formatMessage((0, $2d171512d668e5ad$export$a7357cdd1f0b0168).summaryDescription, {
        link: link
    });
    const defaultStrictDescriptionDisplayedTextNode = intl.formatMessage((0, $iDrrr.fg)('product-terminology-refresh') ? (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).strictDescriptionAppify : (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).strictDescription, {
        bold: (msg)=>msg
    });
    // ReactIntl requires interpolated values to be passed in, and this particular string requires a <bold> modifier.
    // Unfortunately, this converts the above formatted message to a ReactNode but ConsentHub needs strings for `displayedText`,
    // thus, we have to render to a static HTML string first and sanitize the result
    const defaultStrictDescriptionDisplayedText = $95f2e490b44865a6$var$extractTextFromReactNode(defaultStrictDescriptionDisplayedTextNode);
    let defaultDisplayedText = `${defaultSummaryDescriptionDisplayedText}. ${defaultStrictDescriptionDisplayedText}`;
    const sanitizedText = defaultDisplayedText.replace(/&#x27;/g, "'");
    return sanitizedText;
};
const $95f2e490b44865a6$var$getCookieCategories = (intl)=>{
    const cookieCategoriesToTranslate = [
        {
            // Tracks Functional related cookies like preferences
            category: (0, $TTB05.PreferenceCategory).Functional,
            title: (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).functionalOption,
            description: (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).functionalOptionDescription
        },
        {
            // Tracks Performance related cookies like analytics
            category: (0, $TTB05.PreferenceCategory).Analytics,
            title: (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).analyticalOption,
            description: (0, $iDrrr.fg)('product-terminology-refresh') ? (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).analyticalOptionDescriptionAppify : (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).analyticalOptionDescription
        },
        {
            // Tracks Targeting related cookies like marketing and advertising
            category: (0, $TTB05.PreferenceCategory).Marketing,
            title: (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).marketingOption,
            description: (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).marketingOptionDescription
        }
    ];
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $a43d3eee5666acfd$export$99df83ca0f45bd54).reduce((translatedTextMap, category)=>{
        // Set the description as the default for all items (including items with checkboxes in the UI)
        // and we'll override as needed. Prefs that are not visually displayed in the UI anymore will use this default.
        translatedTextMap[category] = $95f2e490b44865a6$var$getDefaultText(intl);
        return translatedTextMap;
    }, {});
    const checkboxes = cookieCategoriesToTranslate.map(({ category: category, title: title, description: description })=>{
        const translatedTitle = intl.formatMessage(title);
        const translatedDescription = intl.formatMessage(description);
        // If we are showing individual checkboxes, use that description for auditing purposes
        displayedTextMap[category] = translatedDescription;
        return {
            category: category,
            titleElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $95f2e490b44865a6$var$categoryNameStyles
            }, translatedTitle),
            descriptionElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, translatedDescription),
            titleString: title.defaultMessage
        };
    });
    return {
        checkboxes: checkboxes,
        displayedTextMap: displayedTextMap
    };
};
const $95f2e490b44865a6$var$noop = ()=>{};
const $95f2e490b44865a6$var$CustomHeader = ({ onClose: onClose })=>{
    const { titleId: titleId } = (0, $aGB72.useModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $95f2e490b44865a6$var$customHeaderStyles,
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
        onClick: onClose,
        testId: "close-modal-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h1",
        size: "medium",
        id: titleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).title)));
};
const $95f2e490b44865a6$export$9921ee7829a3ba4 = ({ preferences: preferences, setPreferencesData: setPreferencesData = $95f2e490b44865a6$var$noop, onSubmit: onSubmit = $95f2e490b44865a6$var$noop, onClose: onClose = $95f2e490b44865a6$var$noop, setIsOpen: setIsOpen = $95f2e490b44865a6$var$noop })=>{
    const intl = (0, $kSwu1.useIntl)();
    const onCloseModal = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        onClose();
    }, [
        setIsOpen,
        onClose
    ]);
    const onClickCancel = (0, $cozmU.useCallback)(()=>{
        onCloseModal();
        (0, $9Y4TN.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancel',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickClose = (0, $cozmU.useCallback)(()=>{
        onCloseModal();
        (0, $9Y4TN.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'close',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickBackground = (0, $cozmU.useCallback)(()=>{
        onCloseModal();
        (0, $9Y4TN.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'area',
            actionSubjectId: 'background',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickTrackingNoticeLink = (0, $cozmU.useCallback)(()=>{
        (0, $9Y4TN.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentModal'
        });
    }, []);
    const cookieCategories = (0, $cozmU.useMemo)(()=>{
        return $95f2e490b44865a6$var$getCookieCategories(intl);
    }, [
        intl
    ]);
    const handleSubmission = (0, $cozmU.useCallback)(()=>{
        const { displayedTextMap: displayedTextMap } = cookieCategories;
        onSubmit(displayedTextMap);
    }, [
        onSubmit,
        cookieCategories
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClickBackground
    }, (0, $iDrrr.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleSubmission
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95f2e490b44865a6$var$CustomHeader, {
        onClose: onClickClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $2d171512d668e5ad$export$a7357cdd1f0b0168).summaryDescription,
        values: {
            link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.Anchor), {
                href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).trackingLink))
        },
        tagName: 'p'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $iDrrr.fg)('product-terminology-refresh') ? (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).strictDescriptionAppify : (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).strictDescription,
        values: {
            bold: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
                    weight: "bold"
                }, msg)
        },
        tagName: 'p'
    })), cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8789ec7a75950bdd$export$3c97a3b492e10ae9), {
            category: category,
            titleElement: titleElement,
            titleString: titleString,
            descriptionElement: description,
            isChecked: (preferences && preferences[category]) ?? false,
            setPreferencesData: setPreferencesData
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: onClickCancel,
        testId: "consent-preference-cancel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).cancelBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        type: "submit",
        appearance: "primary",
        onClick: handleSubmission,
        testId: "consent-preference-confirm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).confirmBtn)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleSubmission
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95f2e490b44865a6$var$CustomHeader, {
            onClose: onClickClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $2d171512d668e5ad$export$a7357cdd1f0b0168).summaryDescription,
            values: {
                link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.Anchor), {
                    href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                    target: "_blank",
                    onClick: onClickTrackingNoticeLink
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).trackingLink))
            },
            tagName: 'p'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $iDrrr.fg)('product-terminology-refresh') ? (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).strictDescriptionAppify : (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).strictDescription,
            values: {
                bold: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
                        weight: "bold"
                    }, msg)
            },
            tagName: 'p'
        })), cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8789ec7a75950bdd$export$3c97a3b492e10ae9), {
                category: category,
                titleElement: titleElement,
                titleString: titleString,
                descriptionElement: description,
                isChecked: (preferences && preferences[category]) ?? false,
                setPreferencesData: setPreferencesData
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            onClick: onClickCancel,
            testId: "consent-preference-cancel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).cancelBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            type: "submit",
            appearance: "primary",
            onClick: handleSubmission,
            testId: "consent-preference-confirm"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2d171512d668e5ad$export$a7357cdd1f0b0168).confirmBtn)))))));
};









var $4nhQC = parcelRequire("4nhQC");


/**
 * This function is responsible for loading the user's preferences from storage, and setting the state accordingly.
 * If the user's preferences are not found in storage, the default preferences will be used.
 */ const $b4014ff8e61470a7$var$loadStoredPreferences = async ({ setPreferencesData: setPreferencesData, isInitialRender: isInitialRender })=>{
    const prefs = await (0, $4nhQC.getPreferences)();
    // If something has gone wrong during this `get` process (invalid token, failed request, etc.)
    // these preferences will be undefined and we'll need to show the banner as we're in an unknown state
    setPreferencesData({
        prefs: prefs,
        isPrefetchedPrefsInternalState: Boolean(prefs)
    });
    // Set the initialRender flag to false so we can skip logic in banner rendering
    if (isInitialRender) isInitialRender.current = false;
};
/**
 * This hook is responsible for handling any initially provided preference data, and/or fetching missing preference
 * data from ConsentHub. It will then set the appropriate cookies and state for the user's preferences to be used
 * throughout the application.

 * @param (optional) initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @returns (object) {
 * 	preferences - The current state of the user's preferences after fetching/transforming/setting cookies
 *	isPrefetchedPreferencesState - A boolean that indicates if we are in a prefetched internal state
 *	setPreferencesData - Setter function to update the preferences state
 *	isInitialRender - A boolean that indicates if this is the first render of the component
 * }
 */ const $b4014ff8e61470a7$var$usePreferences = ({ initialPreferences: initialPreferences })=>{
    /**
	 * isInitialRender is used to ensure consistent banner visibility by addressing potential mismatches that occur
	 *  during the initial render. Without this flag, the application might incorrectly display a banner based on
	 * incomplete or missing preference data. During the rehydration process, this initial render triggers
	 * the useMemo and useEffect hooks which means that initialPreferences may be undefined due to the asynchronous
	 * nature of setting props. This can lead to discrepancies in banner visibility between the SSR state
	 * and the client-rendered state.
	 */ const isInitialRender = (0, $cozmU.useRef)(true);
    const prefetchedPreferencesData = (0, $cozmU.useRef)(initialPreferences);
    const [preferencesData, setPreferencesData] = (0, $cozmU.useState)((0, $fkeeB.initializePreferencesData)(initialPreferences));
    (0, $cozmU.useEffect)(()=>{
        const { prefs: unpackedPrefetchedPrefs, isPrefetchedPrefsInternalState: isPrefetchedPrefsInternalState } = (0, $fkeeB.initializePreferencesData)(prefetchedPreferencesData.current);
        if (!isPrefetchedPrefsInternalState && unpackedPrefetchedPrefs) // With a valid set of prefs, set them on the cookies, but don't save to ConsentHub
        (0, $b25b202b7ea25dac$export$7bb3e177c1a1e841)(unpackedPrefetchedPrefs, undefined, true);
        // On initial render, this will either set the proper preferences in state + required cookies based on the
        // prefetched data, or fetch all of that data from ConsentHub and then set appropriate cookies + state.
        $b4014ff8e61470a7$var$loadStoredPreferences({
            setPreferencesData: setPreferencesData,
            isInitialRender: isInitialRender
        });
    }, [
        isInitialRender
    ]);
    return {
        preferences: preferencesData?.prefs,
        isPrefetchedPreferencesState: preferencesData?.isPrefetchedPrefsInternalState,
        setPreferencesData: setPreferencesData,
        isInitialRender: isInitialRender.current
    };
};
var $b4014ff8e61470a7$export$2e2bcd8739ae039 = $b4014ff8e61470a7$var$usePreferences;


const $115d77451ca22bad$export$94c5684831c222e7 = (props)=>{
    if ((0, $iDrrr.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $iDrrr.fg)('platform_moonjelly_bsc_ui_killswitch')) // Don't render the preference modal if the killswitch is enabled
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($115d77451ca22bad$export$30df3cfccbe10e6e, props);
};
const $115d77451ca22bad$export$30df3cfccbe10e6e = ({ onClose: onClose, onSubmit: onSubmit, showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag, shouldAddWrappers: shouldAddWrappers = true })=>{
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(true);
    const isEventSent = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!isEventSent.current) {
            (0, $9Y4TN.sendScreenEvent)({
                name: 'cookieConsentModal'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent
    ]);
    const { preferences: preferences, setPreferencesData: setPreferencesData } = (0, $b4014ff8e61470a7$export$2e2bcd8739ae039)({});
    // If we don't have preferences, set default preferences
    // for modal interactions
    if (!preferences) setPreferencesData({
        prefs: (0, $bkTet.ONLY_NECESSARY_PREFERENCES),
        isPrefetchedPrefsInternalState: false
    });
    const handleOnSubmit = (0, $cozmU.useCallback)(async (displayedTextMap)=>{
        if (preferences) {
            const selectedPreferences = preferences;
            (0, $9Y4TN.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirm',
                source: 'cookieConsentModal'
            });
            try {
                await (0, $b25b202b7ea25dac$export$7bb3e177c1a1e841)(selectedPreferences, displayedTextMap);
                (0, $9Y4TN.sendTrackEvent)({
                    source: 'cookieConsentModal',
                    action: 'submitted',
                    actionSubject: 'cookieConsentPreferences'
                });
                showSuccessFlag?.();
            } catch (e) {
                (0, $8Qsoy.Logger).errorWithOperationalEvent({
                    action: 'updatePreferencesError',
                    attributes: {
                        preferences: selectedPreferences
                    },
                    message: `Failed to update preferences from modal. ${e.message || ''}`
                });
                showErrorFlag?.();
            }
            setIsModalOpen(false);
            onSubmit?.();
        } else // Preferences have reached an invalid state, show error flag
        showErrorFlag?.();
    }, [
        preferences,
        onSubmit,
        showSuccessFlag,
        showErrorFlag
    ]);
    const modalContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95f2e490b44865a6$export$9921ee7829a3ba4), {
        onSubmit: handleOnSubmit,
        onClose: onClose,
        setIsOpen: setIsModalOpen,
        preferences: preferences ?? (0, $bkTet.ONLY_NECESSARY_PREFERENCES),
        setPreferencesData: setPreferencesData
    });
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldAddWrappers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32a81d6e2279fe8c$export$9aa38aed134c207f), null, modalContent)) : modalContent);
};










var $ad7Ou = parcelRequire("ad7Ou");


var $eh6Ml = parcelRequire("eh6Ml");






var $kz1Yj = parcelRequire("kz1Yj");




var $gnKXs = parcelRequire("gnKXs");


var $lpNn5 = parcelRequire("lpNn5");



const $f18b992a364f5ec9$var$boxStylesPurpleWithMinHeight = (0, $buxP3.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.discovery',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $f18b992a364f5ec9$var$noticeContainerStyles = (0, $buxP3.xcss)({
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'space.200'
});
const $f18b992a364f5ec9$var$inlineWrapperStylesStaticHeight = (0, $buxP3.xcss)({
    // Small & Medium viewport defaults
    gap: 'space.100',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    [(0, $gnKXs.media).above.md]: {
        gap: 'space.300',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const $f18b992a364f5ec9$var$buttonContainerStylesStaticHeight = (0, $buxP3.xcss)({
    minWidth: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    justifyContent: 'start',
    [(0, $gnKXs.media).above.md]: {
        marginLeft: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row'
    }
});
const $f18b992a364f5ec9$var$truncatedTextStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    flex: '0 1 auto'
});
const $f18b992a364f5ec9$var$linkNoTruncateStyles = (0, $buxP3.xcss)({
    flex: '0 0 auto',
    whiteSpace: 'nowrap'
});
const $f18b992a364f5ec9$var$smallMediumScreenContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'space.050',
    alignItems: 'baseline',
    [(0, $gnKXs.media).above.md]: {
        display: 'none'
    }
});
const $f18b992a364f5ec9$var$largeScreenContainerStyles = (0, $buxP3.xcss)({
    display: 'none',
    [(0, $gnKXs.media).above.md]: {
        display: 'block'
    }
});
const $f18b992a364f5ec9$var$noop = ()=>{};
const $f18b992a364f5ec9$var$getDisplayedTextMap = (intl)=>{
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $a43d3eee5666acfd$export$99df83ca0f45bd54).reduce((translatedTextMap, category)=>{
        const linkToCookiesTrackingNotice = intl.formatMessage((0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).cookiesTrackingNotice);
        const bannerDescription = intl.formatMessage((0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).useCookiesDescription, {
            linkToCookiesTrackingNotice: linkToCookiesTrackingNotice
        });
        // Set this for all items (including items with checkboxes in the UI), we'll override as needed below
        // for things like strictlyNecessary/acceptAll
        translatedTextMap[category] = bannerDescription;
        return translatedTextMap;
    }, {});
    return displayedTextMap;
};
const $f18b992a364f5ec9$var$updateDisplayedTextMap = (intl, displayTextMap, isOnlyNecessary)=>{
    const updatedDisplayedTextMap = {
        ...displayTextMap
    };
    // Use description as message to translate
    const onlyNecessaryContent = intl.formatMessage((0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).onlyNecessaryBtn);
    const acceptAllContent = intl.formatMessage((0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).acceptAllBtn);
    // For additional auditing content, append the description related to the button when pressed
    Object.keys(updatedDisplayedTextMap).forEach((key)=>{
        const preferenceCategory = key;
        const additionalContent = isOnlyNecessary ? onlyNecessaryContent : acceptAllContent;
        const textContent = updatedDisplayedTextMap[preferenceCategory];
        updatedDisplayedTextMap[preferenceCategory] = `${additionalContent} \u{2014} ${textContent}`;
    });
    return updatedDisplayedTextMap;
};
const $f18b992a364f5ec9$export$dd3e60478510f81d = ({ onClickOnlyNecessary: onClickOnlyNecessary = $f18b992a364f5ec9$var$noop, onClickAcceptAll: onClickAcceptAll = $f18b992a364f5ec9$var$noop, onClickPreferences: onClickPreferences = $f18b992a364f5ec9$var$noop, onClickTrackingNoticeLink: onClickTrackingNoticeLink = $f18b992a364f5ec9$var$noop, minWidth: minWidth = 400, newMinHeight: newMinHeight = 105 })=>{
    const intl = (0, $kSwu1.useIntl)();
    const displayedTextMap = (0, $cozmU.useMemo)(()=>{
        return $f18b992a364f5ec9$var$getDisplayedTextMap(intl);
    }, [
        intl
    ]);
    const handleOnlyNecessaryClick = (0, $cozmU.useCallback)(()=>{
        const displayedTextOnlyNecessaryMap = $f18b992a364f5ec9$var$updateDisplayedTextMap(intl, displayedTextMap, true);
        onClickOnlyNecessary(displayedTextOnlyNecessaryMap);
    }, [
        onClickOnlyNecessary,
        intl,
        displayedTextMap
    ]);
    const handleAcceptAllClick = (0, $cozmU.useCallback)(()=>{
        const displayedTextAcceptAllMap = $f18b992a364f5ec9$var$updateDisplayedTextMap(intl, displayedTextMap);
        onClickAcceptAll(displayedTextAcceptAllMap);
    }, [
        onClickAcceptAll,
        intl,
        displayedTextMap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        role: "dialog",
        "aria-labelledby": "cookiesTrackingNoticeLink",
        xcss: $f18b992a364f5ec9$var$boxStylesPurpleWithMinHeight,
        style: {
            minWidth: `${minWidth}px`,
            // If you are updating the minHeight, please also update the MIN_BANNER_HEIGHT in confluence/next/packages/cookies-consent-banner/src/useCookiesConsentBanner.ts
            minHeight: `${newMinHeight}px`,
            height: `${newMinHeight}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        xcss: $f18b992a364f5ec9$var$inlineWrapperStylesStaticHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        xcss: $f18b992a364f5ec9$var$noticeContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        xcss: $f18b992a364f5ec9$var$smallMediumScreenContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).useCookiesDescriptionNoLink),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        xcss: $f18b992a364f5ec9$var$truncatedTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).useCookiesDescriptionNoLink,
        tagName: "span"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.Anchor), {
        id: "cookiesTrackingNoticeLink",
        href: "https://www.atlassian.com/legal/cookies",
        target: "_blank",
        onClick: onClickTrackingNoticeLink,
        xcss: $f18b992a364f5ec9$var$linkNoTruncateStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).cookiesTrackingNotice))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $f18b992a364f5ec9$var$largeScreenContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).useCookiesDescription,
        tagName: "span",
        values: {
            linkToCookiesTrackingNotice: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.Anchor), {
                id: "cookiesTrackingNoticeLink",
                href: "https://www.atlassian.com/legal/cookies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).cookiesTrackingNotice))
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        space: "space.100",
        xcss: $f18b992a364f5ec9$var$buttonContainerStylesStaticHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: "preferences-button",
        appearance: "subtle",
        onClick: onClickPreferences
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).preferencesBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: "only-necessary-button",
        onClick: handleOnlyNecessaryClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).onlyNecessaryBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: "accept-all-button",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))),
        onClick: handleAcceptAllClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).acceptAllBtn)))));
};











var $k2dj2 = parcelRequire("k2dj2");





var $gYhNH = parcelRequire("gYhNH");










const $245ad10a36a76b94$export$f6e8c8e54d2f31fe = (isInitialRender, initialPreferences, ssrOptions)=>{
    // We don't have a great way to handle dealing with consent timestamps right here, as we have no global state/store, so we have to precompute
    // banner visibility state when we fetch consents, and store it in a cookie to be read later, here.
    const shouldShowBannerBit = ssrOptions?.getCookie ? ssrOptions.getCookie((0, $bkTet.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)) : (0, $1Qi0Q.getCookie)((0, $bkTet.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
    const inFlowWhereBannerStateIsUnknown = initialPreferences && isInitialRender && shouldShowBannerBit === undefined;
    if ((ssrOptions?.isSSR ?? (0, $k2dj2.isSSR)()) || inFlowWhereBannerStateIsUnknown) {
        // When coming from SSR, this hook will only execute once and won't update later
        // Instead, if we're on the server, have initial preference data with valid consents, don't render
        // On later checks (rehydration), this will always fail and skip to the normal rendering logic
        // Once we're rehydrating, if have been provided initial prefs (from SSR), on the "first render", the banner cookie may still be missing.
        // Due to React lifecycle where this useMemo is executing prior to the useEffect in the usePreferences hook, which sets the core cookies.
        // We should give this flow the same treatment as rendering in an SSR context to match the behavior of the SSR flow to reduce any potential UX flicker.
        if (initialPreferences === (0, $TTB05.PrefetchedPreferenceState).INTERNAL) // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
        // if the user has consented or not yet since we need to fetch, so show the banner
        return true;
        // shouldRenderBannerPrefetched is the single source of truth for SSR/hydration banner visibility.
        // It is used here and by all external consumers (e.g. useCookiesConsentBanner) to guarantee
        // consistent decisions, including correct handling of fallbackConsentToken.
        //
        // Cast: PrefetchedConsentPreferenceData is a narrower type than PrefetchedConsentPreferences —
        // it excludes PrefetchedPreferenceState (handled above) but is otherwise compatible at this call site.
        return (0, $gYhNH.shouldRenderBannerPrefetched)(initialPreferences, ssrOptions);
    }
    const shouldShowBanner = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
    return shouldShowBanner;
};
/**
 * This hook is responsible for determining whether or not the consent banner should be shown based on the user's
 * preferences and the current state of the banner cookie, as well as if the we're rendering from an SSR context.
 *
 * @param preferences - The current state of the user's preferences
 * @param initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @param isInitialRender - A boolean to track if this is the "first" render of the component
 * @param isPrefetchedPreferencesState - A boolean that indicates if are fetching consents internally to our component
 * @returns showBanner - Whether or not the banner should be shown
 * @returns setIsDismissed - Setter function to update the dismissed state of the banner
 */ const $245ad10a36a76b94$var$useBannerVisibility = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, ssrOptions: ssrOptions })=>{
    const isEventSent = (0, $cozmU.useRef)(false);
    const [isDismissed, setIsDismissedProp] = (0, $cozmU.useState)(false);
    const setIsDismissed = (isDismissed)=>{
        if (isDismissed) (0, $cnzke.setStrictlyNecessaryCookie)((0, $bkTet.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY), Date.now().toString(), {
            path: '/'
        });
        setIsDismissedProp(isDismissed);
    };
    const showBanner = (0, $cozmU.useMemo)(()=>{
        return $245ad10a36a76b94$export$4ea0ccb8ff519056({
            preferences: preferences,
            initialPreferences: initialPreferences,
            isInitialRender: isInitialRender,
            isPrefetchedPreferencesState: isPrefetchedPreferencesState,
            isDismissed: isDismissed,
            ssrOptions: ssrOptions
        });
    }, [
        isInitialRender,
        initialPreferences,
        isPrefetchedPreferencesState,
        preferences,
        isDismissed,
        ssrOptions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isEventSent.current && showBanner) {
            (0, $9Y4TN.sendScreenEvent)({
                name: 'cookieConsentBanner'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent,
        showBanner
    ]);
    return {
        showBanner: showBanner,
        setIsDismissed: setIsDismissed
    };
};
const $245ad10a36a76b94$export$4ea0ccb8ff519056 = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isDismissed: isDismissed, ssrOptions: ssrOptions })=>{
    if ((0, $3uUvc.getBscGlobalState)().localConsentMode) {
        // In V1, we only checked based on the existence of the preferences
        const prefsMissing = !preferences;
        if (ssrOptions?.isSSR ?? (0, $k2dj2.isSSR)()) // This logic will execute normally in V2, but for now, as SSR prefetching has not been implemented completely
        // just hide the banner if we're missing the data (always will be in SSR-context) and let the UI handle it on rehydration
        return !prefsMissing && !isDismissed;
        return prefsMissing && !isDismissed;
    }
    const shouldShowBanner = $245ad10a36a76b94$export$f6e8c8e54d2f31fe(isInitialRender, initialPreferences, ssrOptions);
    const unknownPreferences = !isPrefetchedPreferencesState && !preferences;
    return (unknownPreferences || shouldShowBanner) && !isDismissed;
};
var $245ad10a36a76b94$export$2e2bcd8739ae039 = $245ad10a36a76b94$var$useBannerVisibility;


const $0d7d274450a52bad$var$SuccessWithIntl = (0, $kSwu1.injectIntl)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: intl.formatMessage({
            id: "browser-storage-controls.consent-banner.toast.success",
            defaultMessage: "Success"
        }),
        spacing: (0, $iDrrr.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $0d7d274450a52bad$var$ErrorWithIntl = (0, $kSwu1.injectIntl)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: intl.formatMessage({
            id: "browser-storage-controls.consent-banner.toast.error",
            defaultMessage: "Error"
        }),
        spacing: (0, $iDrrr.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $0d7d274450a52bad$var$errorToastProps = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d7d274450a52bad$var$ErrorWithIntl, null),
        appearance: 'normal'
    });
const $0d7d274450a52bad$var$successToastProps = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d7d274450a52bad$var$SuccessWithIntl, null),
        appearance: 'normal',
        isAutoDismiss: true
    });
const $0d7d274450a52bad$export$24af610f9b900e82 = ({ onShow: onShow, onHide: onHide, initialPreferences: initialPreferences, minWidth: minWidth = 400, product: product, onConsentBannerBailOut: onConsentBannerBailOut, analyticsEnabled: analyticsEnabled = true, localConsentMode: localConsentMode = false, newMinHeight: newMinHeight, ssrOptions: ssrOptions, perimeter: perimeter })=>{
    const firstRender = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        if (!firstRender.current) return;
        // Send an operational event if the banner is shown after previously having
        // been dismissed. This will help prevent issues with the banner
        // inappropriately reappearing.
        const lastBannerDismissal = (0, $1Qi0Q.getCookie)((0, $bkTet.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        if (lastBannerDismissal) {
            const timeSinceDismissal = Date.now() - new Date(Number.parseInt(lastBannerDismissal)).getTime();
            const lessThanOneHour = timeSinceDismissal < 3600000;
            const lessThanOneDay = timeSinceDismissal < 86400000;
            const lessThanOneWeek = timeSinceDismissal < 604800000;
            (0, $9Y4TN.sendPackageOperationalEvent)({
                action: 'bannerAppearanceAfterDismissal',
                attributes: {
                    timeSinceDismissal: timeSinceDismissal,
                    lessThanOneHour: lessThanOneHour,
                    lessThanOneDay: lessThanOneDay,
                    lessThanOneWeek: lessThanOneWeek
                }
            });
            (0, $6LqoL.deleteCookie)((0, $bkTet.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        }
        firstRender.current = false;
    }, []);
    (0, $cozmU.useEffect)(()=>{
        (0, $B5pjk.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode,
            perimeter: perimeter
        });
    }, [
        analyticsEnabled,
        product,
        localConsentMode,
        perimeter
    ]);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { preferences: preferences, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isInitialRender: isInitialRender } = (0, $b4014ff8e61470a7$export$2e2bcd8739ae039)({
        initialPreferences: initialPreferences
    });
    const { showBanner: showBanner, setIsDismissed: setIsDismissed } = (0, $245ad10a36a76b94$export$2e2bcd8739ae039)({
        preferences: preferences,
        isPrefetchedPreferencesState: isPrefetchedPreferencesState,
        initialPreferences: initialPreferences,
        isInitialRender: isInitialRender,
        ssrOptions: ssrOptions
    });
    const closePreferenceModal = (0, $cozmU.useCallback)(()=>{
        setIsPreferencesModalOpen(false);
    }, [
        setIsPreferencesModalOpen
    ]);
    const onPreferenceModalSubmit = (0, $cozmU.useCallback)(()=>{
        closePreferenceModal();
        setIsDismissed(true);
    }, [
        closePreferenceModal,
        setIsDismissed
    ]);
    const onClickPreferences = (0, $cozmU.useCallback)(()=>{
        setIsPreferencesModalOpen(true);
        (0, $9Y4TN.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preferences',
            source: 'cookieConsentBanner'
        });
    }, []);
    const showSuccessFlag = (0, $cozmU.useCallback)(()=>{
        if (localConsentMode) showFlag({
            ...$0d7d274450a52bad$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).successFlagDescriptionLocalOnly),
            title: intl.formatMessage((0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).successFlagTitle)
        });
        else showFlag({
            ...$0d7d274450a52bad$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).successFlagDescription),
            title: intl.formatMessage((0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).successFlagTitle)
        });
    }, [
        intl,
        localConsentMode,
        showFlag
    ]);
    const showErrorFlag = (0, $cozmU.useCallback)(()=>{
        showFlag({
            ...$0d7d274450a52bad$var$errorToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).errorFlagDescription),
            title: intl.formatMessage((0, $f9643a32e1be39e4$export$a7357cdd1f0b0168).errorFlagTitle)
        });
    }, [
        intl,
        showFlag
    ]);
    // Sets preferences to allow only Strictly Necessary cookies
    const onClickOnlyNecessary = (0, $cozmU.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $9Y4TN.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'onlyNecessary',
                source: 'cookieConsentBanner'
            });
            await (0, $b25b202b7ea25dac$export$7bb3e177c1a1e841)((0, $bkTet.ONLY_NECESSARY_PREFERENCES), displayedTextMap);
            (0, $9Y4TN.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $8Qsoy.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $bkTet.ONLY_NECESSARY_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    // Sets preferences to allow all categories of cookies
    const onClickAcceptAll = (0, $cozmU.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $9Y4TN.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'acceptAll',
                source: 'cookieConsentBanner'
            });
            await (0, $b25b202b7ea25dac$export$7bb3e177c1a1e841)((0, $bkTet.ACCEPT_ALL_PREFERENCES), displayedTextMap);
            (0, $9Y4TN.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $8Qsoy.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $bkTet.ACCEPT_ALL_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    const onClickTrackingNoticeLink = (0, $cozmU.useCallback)(()=>{
        (0, $9Y4TN.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentBanner'
        });
    }, []);
    // Call onShow/onHide as a side effect of showBanner changing, rather than
    // possibly having to call them in multiple places.
    (0, $cozmU.useEffect)(()=>{
        if (showBanner) (0, $gXfti.addUFOCustomData)({
            isCookieConsentBannerDisplayed: true
        });
        if (showBanner) onShow?.();
        else if (!showBanner) onHide?.();
    }, [
        showBanner,
        onShow,
        onHide
    ]);
    (0, $cozmU.useEffect)(()=>{
        // when banner is not visible and isPrefetchedPreferencesState is in "resolved" state
        if (!showBanner && isPrefetchedPreferencesState !== undefined) // report "banner decided not to show" to sync decision with other components
        onConsentBannerBailOut?.();
    }, [
        showBanner,
        isPrefetchedPreferencesState,
        onConsentBannerBailOut
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32a81d6e2279fe8c$export$9aa38aed134c207f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f18b992a364f5ec9$export$dd3e60478510f81d), {
        onClickOnlyNecessary: onClickOnlyNecessary,
        onClickAcceptAll: onClickAcceptAll,
        onClickPreferences: onClickPreferences,
        onClickTrackingNoticeLink: onClickTrackingNoticeLink,
        minWidth: minWidth,
        newMinHeight: newMinHeight
    }), isPreferencesModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $115d77451ca22bad$export$94c5684831c222e7), {
        onClose: closePreferenceModal,
        onSubmit: onPreferenceModalSubmit,
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag,
        shouldAddWrappers: false
    })));
};


const $4f2f160e47edca8c$export$903b95b8397e77e9 = (props)=>{
    if ((0, $iDrrr.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $iDrrr.fg)('platform_moonjelly_bsc_ui_killswitch')) {
        const { onConsentBannerBailOut: onConsentBannerBailOut } = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $cozmU.useEffect)(()=>{
            onConsentBannerBailOut?.();
        }, [
            onConsentBannerBailOut
        ]);
        // Don't render the consent banner if the killswitch is enabled
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "consent-banner-render-error"
            }),
        onError: (e)=>{
            (0, $8Qsoy.Logger).errorWithOperationalEvent({
                action: 'renderConsentBannerError',
                message: e.message || ''
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0d7d274450a52bad$export$24af610f9b900e82), props)));
};



var $luv00 = parcelRequire("luv00");

const $12d57fb9dae056e4$export$e809c952bdb1ec4c = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let props;
    if ($[0] !== t0) {
        ({ ...props } = t0);
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4f2f160e47edca8c$export$903b95b8397e77e9), props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== ssrPlaceholderIdProp || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...ssrPlaceholderIdProp,
            "data-vc": "consent-banner-wrapper"
        }, t1);
        $[4] = ssrPlaceholderIdProp;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
module.exports["ConsentBannerWrapper"] = $12d57fb9dae056e4$export$e809c952bdb1ec4c;

});

parcelRegister("7akNQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $iXRmn = parcelRequire("iXRmn");


var $lqtHz = parcelRequire("lqtHz");

const $08beb25a8c4ef160$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $08beb25a8c4ef160$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
            value: api,
            children: children
        });
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($08beb25a8c4ef160$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent,
            children: t5
        });
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t4,
                t6
            ]
        });
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag_1)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
                    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
                    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
                        ...restProps,
                        key: flag_1.id
                    });
                })
            })
        ]
    });
};
function $08beb25a8c4ef160$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
module.exports["FlagsProvider"] = $08beb25a8c4ef160$export$a4270ab432ac8a58;

});

parcelRegister("iXRmn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bbe556224ecd1c1b$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["FlagContext"] = $bbe556224ecd1c1b$export$2eb95677cf2465e1;

});

parcelRegister("4MnFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iXRmn = parcelRequire("iXRmn");

const $878d7a55fd1744f7$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
module.exports["useFlags"] = $878d7a55fd1744f7$export$2879604e6aec4ab;

});

parcelRegister("64VTj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fKN6m = parcelRequire("fKN6m");


var $471nw = parcelRequire("471nw");

const $8ae958986c8c799d$var$IntlMessagesProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $8ae958986c8c799d$export$2e2bcd8739ae039 = $8ae958986c8c799d$var$IntlMessagesProvider;
module.exports["default"] = $8ae958986c8c799d$export$2e2bcd8739ae039;

});

parcelRegister("fKN6m", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ezgjU = parcelRequire("ezgjU");

const $8781597542fb3a9a$export$4d17e2d9c5348842 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $bDgLe.c)(4);
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $8781597542fb3a9a$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    (0, $cozmU.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $8781597542fb3a9a$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $8781597542fb3a9a$export$4d17e2d9c5348842;

});

parcelRegister("ezgjU", function(module, exports) {
const $c69670c8f17f7b27$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $c69670c8f17f7b27$export$79618bef82c02d4c;

});

parcelRegister("471nw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ezgjU = parcelRequire("ezgjU");

// Prevents memory leaks
const $2a38add47fc8c1ad$var$cache = (0, $kSwu1.createIntlCache)();
const $2a38add47fc8c1ad$export$f752ac21ea3960a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) return (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $2a38add47fc8c1ad$export$f752ac21ea3960a5;

});

parcelRegister("2tDQa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $afb5d39523e3ca93$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $f67126ae7a7b6015$export$2e2bcd8739ae039 = {
    'browser-storage-controls.consent-banner-modal.analytical.description.101024': 'Measures usage to improve product performance.',
    'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify': 'Measures usage to improve app performance.',
    'browser-storage-controls.consent-banner-modal.analytical.option.082624': 'Allow analytical cookies',
    'browser-storage-controls.consent-banner-modal.cancel.button': 'Cancel',
    'browser-storage-controls.consent-banner-modal.confirm.button': 'Confirm',
    'browser-storage-controls.consent-banner-modal.functional.description.082624': 'Provides enhanced functionality and personalization.',
    'browser-storage-controls.consent-banner-modal.functional.option.082624': 'Allow functional cookies',
    'browser-storage-controls.consent-banner-modal.marketing.description.082624': 'Used for targeted advertising.',
    'browser-storage-controls.consent-banner-modal.marketing.option.082624': 'Allow marketing cookies',
    'browser-storage-controls.consent-banner-modal.strict.description.082624': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.strict.description.082624-appify': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.summary.description.082624': 'Because we value your privacy, you can select which cookies you allow. {link}',
    'browser-storage-controls.consent-banner-modal.title': 'Cookie preferences',
    'browser-storage-controls.consent-banner-modal.tracking.link.082624': 'Review our cookies and tracking notice',
    'browser-storage-controls.consent-banner.accept-all.button': 'Accept all',
    'browser-storage-controls.consent-banner.cookies-description.text': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
    'browser-storage-controls.consent-banner.cookies-description.text.no.link': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
    'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024': 'Atlassian cookies and tracking notice',
    'browser-storage-controls.consent-banner.error-flag.description': 'Try again in a few minutes.',
    'browser-storage-controls.consent-banner.error-flag.title': "We're unable to update the policy",
    'browser-storage-controls.consent-banner.only-necessary.button': 'Only necessary',
    'browser-storage-controls.consent-banner.preferences.button': 'Preferences',
    'browser-storage-controls.consent-banner.success-flag.description': 'You can change this at any time in your Atlassian account.',
    'browser-storage-controls.consent-banner.success-flag.description-local-only': 'Your preferences will only affect this site.',
    'browser-storage-controls.consent-banner.success-flag.title': 'Cookie preferences saved',
    'browser-storage-controls.consent-banner.toast.error': 'Error',
    'browser-storage-controls.consent-banner.toast.success': 'Success'
};


var $afb5d39523e3ca93$export$2e2bcd8739ae039 = (0, $f67126ae7a7b6015$export$2e2bcd8739ae039);

});

parcelRegister("gkwow", function(module, exports) {

let $be37a476da34d3ce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $be37a476da34d3ce$var$load("3Ypi8").then(()=>parcelRequire('48bcm'));

});

parcelRegister("6aK6W", function(module, exports) {

let $47e771ec6f844f93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47e771ec6f844f93$var$load("l2xcG").then(()=>parcelRequire('lAAg1'));

});

parcelRegister("hx6ki", function(module, exports) {

let $cc3a6cff0abd0858$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cc3a6cff0abd0858$var$load("3yLMU").then(()=>parcelRequire('4wbs9'));

});

parcelRegister("6NqkL", function(module, exports) {

let $4f2bbf0bfae9d8d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f2bbf0bfae9d8d1$var$load("iJdvt").then(()=>parcelRequire('bxPKI'));

});

parcelRegister("ajPmq", function(module, exports) {

let $783384ea012d0252$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $783384ea012d0252$var$load("2wkMx").then(()=>parcelRequire('iDPId'));

});

parcelRegister("gT5vh", function(module, exports) {

let $c4b60d4de3033dfe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4b60d4de3033dfe$var$load("4dW90").then(()=>parcelRequire('dwgd7'));

});

parcelRegister("lw3hP", function(module, exports) {

let $fa9f22c409ddb6e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa9f22c409ddb6e1$var$load("lCTsZ").then(()=>parcelRequire('5mYDv'));

});

parcelRegister("kdctd", function(module, exports) {

let $eb6eb1e2e3848d99$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb6eb1e2e3848d99$var$load("aKeK4").then(()=>parcelRequire('6UPsU'));

});

parcelRegister("1PGa9", function(module, exports) {

let $155b428660558006$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $155b428660558006$var$load("aB49F").then(()=>parcelRequire('g3mHz'));

});

parcelRegister("hKcus", function(module, exports) {

let $ceb06bd7cde8bd0a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ceb06bd7cde8bd0a$var$load("58RtN").then(()=>parcelRequire('aXeIX'));

});

parcelRegister("dhpjR", function(module, exports) {

let $9ab080c379699ac9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9ab080c379699ac9$var$load("e6h7G").then(()=>parcelRequire('8H9az'));

});

parcelRegister("8YZ4p", function(module, exports) {

let $68a34c95023a7214$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68a34c95023a7214$var$load("hFVA3").then(()=>parcelRequire('exGJY'));

});

parcelRegister("4N1kk", function(module, exports) {

let $37ccc4890e6cf8eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37ccc4890e6cf8eb$var$load("3MKno").then(()=>parcelRequire('6ZSWI'));

});

parcelRegister("11IwJ", function(module, exports) {

let $0bf86c9292dffa61$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bf86c9292dffa61$var$load("9Bz2u").then(()=>parcelRequire('fwOd0'));

});

parcelRegister("7i3vo", function(module, exports) {

let $54eceeeedd4dd6ce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $54eceeeedd4dd6ce$var$load("2bq1i").then(()=>parcelRequire('hUyZJ'));

});

parcelRegister("eKvi3", function(module, exports) {

let $abcda222cccec039$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $abcda222cccec039$var$load("fg3mU").then(()=>parcelRequire('8JKQy'));

});

parcelRegister("bY0VN", function(module, exports) {

let $8b66053346f1ad4d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b66053346f1ad4d$var$load("1pjuU").then(()=>parcelRequire('3RtDo'));

});

parcelRegister("7yzEr", function(module, exports) {

let $58075cfa428b6082$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $58075cfa428b6082$var$load("1pjuU").then(()=>parcelRequire('6g3Fw'));

});

parcelRegister("1yiJi", function(module, exports) {

let $12177ebbd99a1648$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12177ebbd99a1648$var$load("1pjuU").then(()=>parcelRequire('2YNaK'));

});

parcelRegister("kXi26", function(module, exports) {

let $f4174e46568b7bc8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4174e46568b7bc8$var$load("1pjuU").then(()=>parcelRequire('cOtOe'));

});

parcelRegister("iB2D9", function(module, exports) {

let $d89db90c5c12e623$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d89db90c5c12e623$var$load("9R8bx").then(()=>parcelRequire('g9STO'));

});

parcelRegister("5wSQ4", function(module, exports) {

let $406a7ac065d06853$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $406a7ac065d06853$var$load("6QzUN").then(()=>parcelRequire('4f4i0'));

});

parcelRegister("9GACM", function(module, exports) {

let $70d47223f6840f11$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $70d47223f6840f11$var$load("8R7O6").then(()=>parcelRequire('jvXtL'));

});

parcelRegister("ex0q7", function(module, exports) {

let $a9447932348ce41e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9447932348ce41e$var$load("2hbfy").then(()=>parcelRequire('i48fn'));

});

parcelRegister("ksIbs", function(module, exports) {

let $ee58b22b09661667$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee58b22b09661667$var$load("5VXWH").then(()=>parcelRequire('37JSV'));

});

parcelRegister("1O1cp", function(module, exports) {

let $150b64181d67b5fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $150b64181d67b5fb$var$load("9KPp6").then(()=>parcelRequire('eyXvI'));

});

parcelRegister("bCWCz", function(module, exports) {

let $8770b74066663bb2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8770b74066663bb2$var$load("kL5b6").then(()=>parcelRequire('2mXiQ'));

});

parcelRegister("gnKXs", function(module, exports) {
const $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
module.exports["media"] = $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});


//# sourceMappingURL=ConsentBannerWrapper.0807ec36.js.map
